module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_resort-90485c82b2ee1a38bde1eb5e345aecbe.webp";